import { z, ZodType } from 'zod';
import { ensureWidgetContent, ensureWidgetType, WidgetsName, WidgetType } from './common';

import { zObject } from '../../util/zod';
import { jUserLittleSchema } from '../user';
import { widgetLegacyMixedBooleanSchema } from './legacy';

export const widgetPresenceContentSchema = z.object({
    limit: z.boolean().or(z.number()).optional(),
    limitValue: z.number().optional(),
    closing: widgetLegacyMixedBooleanSchema.optional(),
    isClosed: widgetLegacyMixedBooleanSchema.optional(),
});

export type WidgetPresenceContent = z.infer<typeof widgetPresenceContentSchema>;
export const ensureWidgetPresenceContent = (content: unknown): content is WidgetPresenceContent =>
    ensureWidgetContent(content, widgetPresenceContentSchema);

export type WidgetPresenceType = {
    name: WidgetsName.Presence;
    uniqid: string;
    content: WidgetPresenceContent;
};
export const widgetPresenceTypeSchema = zObject<WidgetPresenceType>({
    name: z.literal(WidgetsName.Presence),
    uniqid: z.string(),
    content: widgetPresenceContentSchema,
}) satisfies ZodType<WidgetType<WidgetPresenceContent>>;

export const ensureWidgetPresenceType = (widget: unknown): widget is WidgetPresenceType =>
    ensureWidgetType(widget, widgetPresenceTypeSchema);

export const widgetPresenceRespondPayloadSchema = z.object({
    id: z.number(),
    type: z.string(),
    uniqid: z.string(),
    value: z.number(),
});

export type WidgetPresenceRespondPayload = z.infer<typeof widgetPresenceRespondPayloadSchema>;

export const ensureWidgetPresenceResponsePayload = (payload: unknown): payload is WidgetPresenceRespondPayload =>
    ensureWidgetType(payload, widgetPresenceRespondPayloadSchema);

export const widgetPresenceResponseSchema = z.object({
    userValue: z.number(),
    userAvailableList: jUserLittleSchema.array(),
    userUnavailableList: jUserLittleSchema.array(),
    userAvailableTotal: z.number(),
    userUnavailableTotal: z.number(),
});

export type WidgetPresenceResponse = z.infer<typeof widgetPresenceResponseSchema>;

export const ensureWidgetPresenceResponse = (payload: unknown): payload is WidgetPresenceResponse =>
    ensureWidgetType(payload, widgetPresenceResponseSchema);

export const WidgetPresenceResponseUserListSchema = z.object({
    data: jUserLittleSchema.array(),
    cnt: z.number(),
    page: z.number(),
    limit: z.number(),
});

export type WidgetPresenceResponseUserList = z.infer<typeof WidgetPresenceResponseUserListSchema>;
